/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */


import { View, Image, Text, TouchableOpacity, Platform } from 'react-native';
import styles from '../Updatedscreen/styles/style';
import style from '../Updatedscreen/styles/style.js';
import { getResponsiveStyle, widthInPercentage } from '../../utils/appUtils';
import React, { Component } from 'react';

class BackButton extends Component {
  constructor(props) {
    super(props);
    this.state = { value: '' };
  }
  onGoBack(data) {
    this.props.onGoBack(data);

  }
  render() {
    const {
      children,
      measure,
      onGoBack,
      heading,
      payamountPage,
      TermsNdConditionpage,
      vehicleDetails
    } = this.props;
    return (

      <View >

        <View
          style={(measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI') &&
            (payamountPage) ?
            [style.HomebuttonsViewMob]
            : [style.HomebuttonsView,
            style[getResponsiveStyle('HomebuttonsView', measure)]]}
        // style={[
        //   style.HomebuttonsView,
        //   style[getResponsiveStyle('HomebuttonsView', measure)]
        // ]}

        >

          <TouchableOpacity
            onPress={() => onGoBack()}
            // style={[
            //   style.HomebuttonsNew,
            //   { backgroundColor: "#e77817", height: payamountPage || TermsNdConditionpage ? measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI' ? 35 : null : null },
            //   style[getResponsiveStyle('HomebuttonsNew', measure)]
            // ]}
            style={(measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI') &&
              (payamountPage) ?
              [style.HomebuttonsNewMob]
              : [style.BackbuttonsNew,
              { backgroundColor: "#e77817", height: payamountPage || TermsNdConditionpage ? measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI' ? 35 : null : null },
              style[getResponsiveStyle('BackbuttonsNew', measure)]]}
          >
            <Text style={{
              fontSize: (measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI') &&
                (payamountPage || TermsNdConditionpage) ? 15 : ((measure === 'XXHDPI') && (vehicleDetails)) ? 16 : 11,
              color: 'white',
              paddingVertical: (measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI') &&
                (payamountPage) ? widthInPercentage(17) : widthInPercentage(27)
            }}>Back</Text>
            {/* <Image
            style={[
              styles.backhomestyle,
              styles[getResponsiveStyle('backhomestyle', measure)]
            ]}
            source={require('../../assets/images/backHome.png')}
          /> */}
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

export default BackButton;
